import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getFirestore, collection, addDoc, query, where, getDocs } from "firebase/firestore";
import AdminHead from "../Admin/AdminHead";
import Loading from "../Components/Loading";
import { FaTrash } from "react-icons/fa";
import "../Styles/Sapakim/SCreateNewOrder.css";

const storage = getStorage();
const firestore = getFirestore();

const woodTypes = ["עץ סנדוויץ בירש + עץ מלא (T25*) רמת''ג (A+)", "עץ סנדוויץ אקומי + עץ מלא (T25*) רמת''ג (A)", "עץ אמ די אף + עץ מלא (T25*) רמת''ג (B)", "עץ סנדוויץ תעשיתי + עץ מלא (פיני 5) רמת''ג (C)"];
const woodType2 = ["עץ סנדוויץ + אמ די אף", "אמ די אף", "סיבית"]
const fabricManufacturers = ["Erotex", "Rafael", "Select", "אחר"];

const shapeOptions = [
  { id: "shape1", label: "צורה 1", img: "https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FFrame%205.png?alt=media&token=70e80504-fab2-4ec5-9a9f-51e61e5706b1" },
  { id: "shape2", label: "צורה 2", img: "https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FFrame%203.png?alt=media&token=5638ac02-373b-4b91-a740-0228218bcbd5" },
  { id: "shape3", label: "צורה 3", img: "https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FFrame%206.png?alt=media&token=2aa046fc-1ea7-456f-b1ee-8bb9a10f6f0d" },
  { id: "shape4", label: "צורה 4", img: "https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FFrame%204.png?alt=media&token=ec668c4e-115d-4c11-810d-6d6291ca7f79" },
];

const removeUndefined = (obj) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined));
};

const generateUniqueOrderNumber = async () => {
  let isUnique = false;
  let orderNumber = "";

  while (!isUnique) {
    orderNumber = Math.floor(100000 + Math.random() * 900000).toString();
    const q = query(collection(firestore, "Orders"), where("orderNumber", "==", orderNumber));
    const querySnapshot = await getDocs(q);
    if (querySnapshot.empty) isUnique = true;
  }

  return orderNumber;
};

function CreateNewOrder() {
  const { UID, CDID } = useParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isValidOrder, setIsValidOrder] = useState(false);
  const nav = useNavigate();

  const [deliveryDate, setDeliveryDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() + 14); 
    return date.toISOString().split("T")[0];
  });

  const addNewItem = () => {
    setItems([
      ...items,
      {
        id: uuidv4(),
        name: "",
        description: "",
        type: "Upholsterer",
        fabricCode: "",
        fabricManufacturer: "",
        woodType: "",
        width: "",
        width2: "",
        height: "",
        depth: "",
        notes: "",
        shape: null,
        imageFiles: [],
      },
    ]);
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;
    setItems(updatedItems);

    const isValid = updatedItems.some(
      (item) => item.name?.trim() && item.description?.trim()
    );
    setIsValidOrder(isValid);
  };

  const handleImageUpload = (index, files) => {
    const updatedItems = [...items];
    updatedItems[index].imageFiles = Array.from(files);
    setItems(updatedItems);
  };

  const removeItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const removeImage = (itemIndex, imageIndex) => {
    const updatedItems = [...items];
    updatedItems[itemIndex].imageFiles = updatedItems[itemIndex].imageFiles.filter(
      (_, i) => i !== imageIndex
    );
    setItems(updatedItems);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const orderNumber = await generateUniqueOrderNumber();
      const uploadedItems = [];

      for (const item of items) {
        if (!item.name.trim() || !item.description.trim()) {
          alert("כל פריט חייב לכלול שם ותיאור.");
          setLoading(false);
          return;
        }

        const imageUrls = await Promise.all(
          item.imageFiles.map(async (file) => {
            const imageRef = ref(storage, `Orders/${orderNumber}/${uuidv4()}`);
            await uploadBytes(imageRef, file);
            return getDownloadURL(imageRef);
          })
        );

        uploadedItems.push(
          removeUndefined({
            name: item.name,
            description: item.description,
            type: item.type,
            fabricCode: item.fabricCode,
            fabricManufacturer: item.fabricManufacturer,
            woodType: item.woodType,
            width: item.width,
            width2: item.width2,
            height: item.height,
            depth: item.depth,
            notes: item.notes,
            shape: item.shape,
            images: imageUrls,
          })
        );
      }

      const orderData = removeUndefined({
        orderNumber,
        SapakId: UID,
        CustomerID: CDID,
        items: uploadedItems,
        createdAt: new Date(),
        Status: "ממתין לאישור",
        deliveryDate: new Date(deliveryDate),
      });
      

      await addDoc(collection(firestore, "Orders"), orderData);
      nav(-1);
    } catch (error) {
      console.error("שגיאה בשליחת ההזמנה:", error);
      alert("שגיאה בשליחת ההזמנה: " + error.message);
    }
    setLoading(false);
  };

  if (loading) return <Loading />;

  return (
    <React.Fragment>
      <AdminHead />
      <div className="order-form-container" dir="rtl">
        <h1>יצירת הזמנה חדשה</h1>

        {items.map((item, index) => (
          <div key={item.id} className="order-item-form">
            <input placeholder="שם המוצר" value={item.name} onChange={(e) => handleItemChange(index, "name", e.target.value)} />
            <textarea placeholder="תיאור" value={item.description} onChange={(e) => handleItemChange(index, "description", e.target.value)} />
            <select value={item.type} onChange={(e) => handleItemChange(index, "type", e.target.value)}>
              <option value="Upholsterer">ריפוד</option>
              <option value="Carpentry">נגרות</option>
            </select>

            {item.type === "Upholsterer" && (
              <>
                <input placeholder="קוד בד" value={item.fabricCode} onChange={(e) => handleItemChange(index, "fabricCode", e.target.value)} />
                <select value={item.fabricManufacturer} onChange={(e) => handleItemChange(index, "fabricManufacturer", e.target.value)}>
                  <option value="">בחר חברת בד</option>
                  {fabricManufacturers.map((m, i) => <option key={i} value={m}>{m}</option>)}
                </select>
                <select value={item.woodType} onChange={(e) => handleItemChange(index, "woodType", e.target.value)}>
                  <option value="">בחר סוג עץ</option>
                  {woodTypes.map((wood, i) => <option key={i} value={wood}>{wood}</option>)}
                </select>

                <div className="shape-selector">
                  <p>בחר צורה:</p>
                  <div className="shapes-grid">
                    {shapeOptions.map((shape) => (
                      <div
                        key={shape.id}
                        className={`shape-option ${item.shape === shape.id ? "selected" : ""}`}
                        onClick={() => handleItemChange(index, "shape", shape.id)}
                      >
                        <img src={shape.img} alt={shape.label} className={`shape-image ${item.shape === shape.id ? "selected" : ""}`} />
                       
                      </div>
                    ))}
                  </div>
                </div>

                {item.shape && (
                  <>
                    <input type="number" placeholder="רוחב 1 (ס\מ)"value={item.width} onChange={(e) => handleItemChange(index, "width", e.target.value)} />
                    <input type="number" placeholder="גובה 2 (ס\מ)" value={item.width2} onChange={(e) => handleItemChange(index, "width2", e.target.value)} />
                    <input type="number" placeholder="עומק (ס\מ)" value={item.depth} onChange={(e) => handleItemChange(index, "depth", e.target.value)} />
                  </>
                )}
              </>
            )}

            {item.type === "Carpentry" && (
              <>
                <select value={item.woodType2} onChange={(e) => handleItemChange(index, "woodType", e.target.value)}>
                  <option value="">בחר סוג עץ</option>
                  {woodType2.map((wood, i) => <option key={i} value={wood}>{wood}</option>)}
                </select>
                <input type="number" placeholder="רוחב (ס\מ)" value={item.width} onChange={(e) => handleItemChange(index, "width", e.target.value)} />
                <input type="number" placeholder="גובה (ס\מ)" value={item.height} onChange={(e) => handleItemChange(index, "height", e.target.value)} />
                <input type="number" placeholder="עומק (ס\מ)" value={item.depth} onChange={(e) => handleItemChange(index, "depth", e.target.value)} />
              </>
            )}

            <textarea placeholder="הערות" value={item.notes} onChange={(e) => handleItemChange(index, "notes", e.target.value)} />
            <input type="file" multiple onChange={(e) => handleImageUpload(index, e.target.files)} />

            <div className="delivery-date-input" dir="rtl">
              <label htmlFor="deliveryDate">תאריך אספקה:</label>
              <input
                type="date"
                id="deliveryDate"
                value={deliveryDate}
                min={new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]} // min 2 weeks
                onChange={(e) => setDeliveryDate(e.target.value)}
              />
            </div>

            {item.imageFiles.length > 0 && (
              <div className="image-preview">
                {item.imageFiles.map((file, i) => (
                  <div key={i} className="image-container">
                    <img src={URL.createObjectURL(file)} alt="תצוגה מקדימה" />
                    <button onClick={() => removeImage(index, i)} className="remove-image-btn">
                      <FaTrash color="red" size={15} />
                    </button>
                  </div>
                ))}
              </div>
            )}

            <button onClick={() => removeItem(index)} className="remove-item-btn">
              הסר פריט
            </button>
          </div>
        ))}

        <button onClick={addNewItem} className="add-item-btn">
          הוסף פריט
        </button>

        {isValidOrder && (
          <button onClick={handleSubmit} className="submit-btn">
            שלח הזמנה
          </button>
        )}
      </div>
    </React.Fragment>
  );
}

export default CreateNewOrder;